import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { OrgChartNode } from "./models/org-chart-node";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, from, Subject } from "rxjs";
import { UsersService } from "../admin/users/users.service";
import { map, takeUntil } from "rxjs/operators";
import { IUser } from "../admin/users/models/IUser";
import { CurrentUserService } from "../shared/services/current-user.service";

@Component({
  selector: "app-org-chart",
  templateUrl: "./org-chart.component.html",
  styleUrls: ["./org-chart.component.scss"],
})
export class OrgChartComponent implements OnInit {
  private nodeMap: { [key: number]: OrgChartNode };
  private destroy = new Subject<any>();
  private loadingBehaviorSubject = new BehaviorSubject<boolean>(false);
  @ViewChild("editSupervisor", { static: false }) editSupervisorModal: ElementRef;
  loading$ = this.loadingBehaviorSubject.asObservable();
  allUsers: IUser[] = [];
  selectedEmployee: OrgChartNode;
  currentUser: IUser;
  orgChart: OrgChartNode[];
  usersToExclude: number[] = [];
  isTreeLoaded: boolean = false;

  constructor(
    private modalService: NgbModal,
    private userService: UsersService,
    currentUserService: CurrentUserService
  ) {
    currentUserService.currentUserData$
      .pipe(takeUntil(this.destroy))
      .subscribe((currentUser) => {
        this.currentUser = currentUser;
      });
  }

  ngOnDestroy() {
    this.destroy.next();
  }
  ngOnInit() {
    this.loadTree();
  }
  loadTree() {
    this.isTreeLoaded = false;
    this.loadingBehaviorSubject.next(true);
    this.userService
      .getUsers()
      .pipe(map((users) => this.arrayToTree(users.filter(u => u.active && u.name != "Admin"))))
      .subscribe(([orgChart, nodeMap]) => {
        this.orgChart = orgChart;
        this.nodeMap = nodeMap
      });
    this.modalService.dismissAll();
    this.loadingBehaviorSubject.next(false);
    this.isTreeLoaded = true;
  }
  editNode(employee: OrgChartNode) {
    if (!this.currentUser.specialPermission) {
      alert("You have no permissions to edit this.");
      return;
    }
    this.selectedEmployee = employee;
    const modalRef = this.modalService.open(this.editSupervisorModal, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
      scrollable: true,
    });
    from(modalRef.result).subscribe({
      next: () => {
        this.loadingBehaviorSubject.next(true);
        employee.supervisorId = this.selectedEmployee.supervisorId;
        this.userService.updateUser(employee).subscribe(() => {
          this.loadTree();
        });
      },
      error: () => {
      },
    });
  }
  getPossibleUsers(): IUser[] {
    this.usersToExclude = [];
    for (var i = 0; i < this.selectedEmployee.employees.length; i++) {
      this.getIdToExclude(this.selectedEmployee.employees[i]);
    }
    return this.allUsers.filter(user => user.id != this.selectedEmployee.id && !this.usersToExclude.includes(user.id));
  }
  getIdToExclude(node: OrgChartNode) {
    this.usersToExclude.push(node.id);
    for (var i = 0; i < node.employees.length; i++) {
      this.usersToExclude.push(node.employees[i].id);
      if (node.employees[i].employees.length > 0) {
        this.getIdToExclude(node.employees[i]);
      }
    }
  }
  disconnectAll() {
    this.loadingBehaviorSubject.next(true);
    this.selectedEmployee.supervisorId = 0;
    for (var i = 0; i < this.selectedEmployee.employees.length; i++) {
      this.disconnectAllEmployees(this.selectedEmployee.employees[i]);
    }
    this.userService.updateUser(this.selectedEmployee).subscribe(() => {
      this.loadTree();
    });
  }
  disconnectAllEmployees(node: OrgChartNode) {
    if (node.supervisorId != 0) {
      node.supervisorId = 0;
      this.userService.updateUser(node).subscribe(() => { });
    }
    for (var i = 0; i < node.employees.length; i++) {
      if (node.supervisorId != 0) {
        node.supervisorId = 0;
        this.userService.updateUser(node).subscribe(() => { });
      }
      this.userService.updateUser(node.employees[i]).subscribe(() => { });
      if (node.employees[i].employees.length > 0) {
        this.disconnectAllEmployees(node.employees[i]);
      }
    }
  }
  private arrayToTree(users: IUser[], expandedNodeIds: number[] = []): [OrgChartNode[], { [key: number]: OrgChartNode }] {
    // find all users with no parentids
    // foreach parent find all kids
    this.allUsers = users;
    const nodeMap: { [key: number]: OrgChartNode } = {};
    const rootNodes: OrgChartNode[] = [];
    users.forEach((user) => {
      const collapsed = expandedNodeIds.indexOf(user.id) === -1;
      nodeMap[user.id] = { ...user, collapsed: collapsed, employees: [] };
    });

    users.forEach((user) => {
      const node = nodeMap[user.id];
      if (!node.supervisorId) {
        rootNodes.push(node);
      } else {
        nodeMap[node.supervisorId].employees.push(node);
      }
    });
    return [rootNodes, nodeMap];
  }
  private getExpandedNodeIds(employees: OrgChartNode[]) {
    const expandedNodeIds: number[] = [];
    employees.forEach((e) => {
      if (e.collapsed === false) {
        expandedNodeIds.push(e.id);
        if (e.employees) {
          expandedNodeIds.push.apply(
            expandedNodeIds,
            this.getExpandedNodeIds(e.employees)
          );
        }
      }
    });
    return expandedNodeIds;
  }
  supervisorSearchFormatter(user: IUser) {
    return user.name;
  }
}
